import { Card, Layout, Text, Divider } from '@loadsmart/miranda-react'

import { type Shipment } from '../domain/Shipment'
import {
  formatPaymentTerm,
  formatThirdPartyBillingInformationAddress,
  formatThirdPartyBillingInformationCityStateCountry,
} from '../presenters/shipmentPresenter'

export type PaymentOverviewCardProps = Readonly<{
  shipment: Shipment
}>
export function PaymentOverviewCard({ shipment }: PaymentOverviewCardProps) {
  return (
    <Card collapsible style={{ minWidth: '300px' }}>
      <Card.Title>
        <Text variant="heading-sm-bold">Payment overview</Text>
      </Card.Title>
      <Card.Divider />
      <Card.Body>
        <Layout.Stack>
          <Layout.Stack gap="spacing-1">
            <Text variant="body-sm" color="color-text-tertiary">
              Payment terms
            </Text>
            <Text variant="body-md">{formatPaymentTerm(shipment)}</Text>
          </Layout.Stack>
          {shipment.paymentTerm === 'third_party' && (
            <>
              <Divider />
              <Layout.Stack gap="spacing-1">
                <Text variant="body-sm" color="color-text-tertiary">
                  Company
                </Text>
                <Text variant="body-md">{shipment.thirdPartyBillingInformation?.companyName}</Text>
              </Layout.Stack>
              <Layout.Stack gap="spacing-1">
                <Text variant="body-sm" color="color-text-tertiary">
                  Address/Zipcode
                </Text>
                <Text variant="body-md">{formatThirdPartyBillingInformationAddress(shipment)}</Text>
              </Layout.Stack>
              <Layout.Stack gap="spacing-1">
                <Text variant="body-sm" color="color-text-tertiary">
                  City/State/Country
                </Text>
                <Text variant="body-md">
                  {formatThirdPartyBillingInformationCityStateCountry(shipment)}
                </Text>
              </Layout.Stack>
            </>
          )}
        </Layout.Stack>
      </Card.Body>
    </Card>
  )
}
